import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/get-requests'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/get-requests'
import type { GetRequestsParams } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/requests/requests'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import { getConfig } from 'config/configuration'

import { getRequestSetDataSaga } from './sagas/get-requests-set-data.saga'
import { getRequestsStartSaga } from './sagas/get-requests-start.saga'

const { endpoints } = getConfig()

const args: RequestArgs<ServerResponse, ClientResponse, GetRequestsParams, never> = {
  url: formatEndpoint(endpoints.api.v4.request),
  method: 'GET',
  handleSuccess,
  handleFailure,
}

const requestsModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, GetRequestsParams>({
    moduleName,
    args,
    sagas: {
      onRequestStartSaga: getRequestsStartSaga,
      onSetDataSaga: getRequestSetDataSaga,
    },
  })

export default requestsModule
